import axios from 'axios';
import moment from 'moment';
import { constructServiceURL } from '../../../../../utils/URLTools';

const apiFetchEditRoute = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'editRoute',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      appContext: payload.appContext.appContext,
    },
  });

  const palletBoxParams = payload.appContext.appContext === 'pallet' ? {
    routeLeadingCounts: payload.params.routeLeadingCounts.map((leadingCountType) => (
      {
        id: leadingCountType.id !== null ? leadingCountType.id : null,
        startDate: moment(leadingCountType.startDate).format('YYYY-MM-DD'),
        endDate: leadingCountType.endDate === null ? null : moment(leadingCountType.endDate).format('YYYY-MM-DD'),
      })),
    transferLocations: payload.params.transferLocations,
  } : {};

  return axios.put(serviceUrl, {
    assetRouteId: payload.params.assetRouteId,
    description: payload.params.description,
    endDate: payload.params.endDate !== null ? moment(payload.params.endDate).format('YYYY-MM-DD') : null,
    priority: payload.params.priority,
    startDate: moment(payload.params.startDate).format('YYYY-MM-DD'),
    ...palletBoxParams,
  });
};

export default apiFetchEditRoute;
